import { Card, CardContent } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import PageHeader from '../../components/shared/PageHeader';
import EmptyState from '../../components/shared/EmptyState';
import SectionHeader from '../../components/shared/SectionHeader';
import { useAppSelector } from '../../store/hooks';

const DashboardPage = () => {
  const user = useAppSelector((state) => state.auth.user);
  const firstName = user?.firstName || 'there';

  return (
    <>
      <PageHeader
        title={`Welcome, ${firstName}`}
        subtitle="Your borrower dashboard — loan details and tasks will appear here."
      />

      <Card>
        <CardContent>
          <SectionHeader title="Your Loans" icon={<HomeOutlinedIcon />} />
          <EmptyState
            title="No loans yet"
            description="When a loan is linked to your account, it will show up here."
          />
        </CardContent>
      </Card>
    </>
  );
};

export default DashboardPage;
